import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, inject, signal } from '@angular/core'
import { form } from '@angular/forms/signals'

import { KirjanpidonProjekti } from '@lemon/core-firebase/model/kirjanpito-projektit'
import { arvonMuutokset, asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { Observable, Subject } from 'rxjs'
import { map, takeUntil } from 'rxjs/operators'

interface ProjektinValintaLomake {
  valittuProjekti: KirjanpidonProjekti | null
}

@Component({
  selector: 'app-kirjanpito-projektit-dropdown',
  templateUrl: './projektit-dropdown.component.html',
  styles: [
    `
      .black-text {
        color: black;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KirjanpitoProjektitDropdownComponent implements OnInit, OnDestroy {
  private _ngUnsubscribe = new Subject<void>()
  private readonly _injector = inject(Injector)

  private kaikkiProjekti: KirjanpidonProjekti = {
    avain: 'kaikki',
    viewableInLemonator: true,
    usableInLemonator: false,
    viewableInLemonaid: false,
    color: 'black',
    nimi: 'Kaikki',
  }

  // private _projektitFromFirestoreObservable: Observable<KirjanpidonProjekti[]>
  displayedProjektitObservable: Observable<KirjanpidonProjekti[]>
  lomake = form(signal<ProjektinValintaLomake>({ valittuProjekti: null }))

  @Input() projektitFromParentObservable: Observable<KirjanpidonProjekti[]>
  @Output() projektiValittu: EventEmitter<string> = new EventEmitter()

  constructor() {}

  ngOnInit() {
    arvonMuutokset(this.lomake.valittuProjekti, { injector: this._injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(val => {
        if (!!val && val.avain !== this.kaikkiProjekti.avain) {
          this.projektiValittu.emit(val.avain)
        } else {
          this.projektiValittu.emit(null)
        }
      })

    this.displayedProjektitObservable = this.projektitFromParentObservable.pipe(
      map(projektit => {
        const raporteillaProjektit: KirjanpidonProjekti[] = projektit?.length ? projektit.filter(pr => pr.viewableInLemonator) : []
        raporteillaProjektit.unshift(this.kaikkiProjekti)
        return raporteillaProjektit
      }),
    )

    asetaArvo(this.lomake.valittuProjekti, this.kaikkiProjekti)
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  compareWith(p1: KirjanpidonProjekti, p2: KirjanpidonProjekti): boolean {
    return p1 && p2 ? p1.avain === p2.avain : p1 === p2
  }
}
